import { ReactElement } from 'react'

import * as Styled from './styles'

/** The thick divider between the detail panel's sections. */
export const ImportedInvoiceDetailDivider = (): ReactElement => <Styled.ImportedInvoiceDetailDividerWrapper />
